import { postEdgeFunctionAction } from '@/clients/postEdgeFunctionAction';
import type { Locale } from '@financialharmony/i18n';

const FUNCTION_NAME = 'user-preferences-api';

/** The signed-in user's own preferences (the UI language so far). */
export const userPreferencesApiClient = {
  /** The stored language as-is: `null` when none is saved, and possibly a value this build no longer supports. */
  async getLocale(): Promise<string | null> {
    const { locale } = await postEdgeFunctionAction<{ locale: string | null }>(FUNCTION_NAME, 'getPreferences');
    return locale;
  },

  async setLocale(locale: Locale): Promise<void> {
    await postEdgeFunctionAction(FUNCTION_NAME, 'setLocale', { locale });
  },
};
